import { useCallback } from 'react'

import { useUserLocale } from './useLocaleColOrUser'

export function useDateFmt(localeOptions?: Intl.DateTimeFormatOptions) {
  const userLocale = useUserLocale()
  return useCallback(
    (date: Date) => {
      return date.toLocaleString(
        userLocale,
        localeOptions
          ? localeOptions
          : {
              dateStyle: 'long',
            }
      )
    },
    [userLocale]
  )
}
